import {
    REQUEST_VENDORS,
    FETCH_VENDORS_SUCCESS,
    FETCH_VENDORS_FAILURE,
    SELECT_VENDOR,
    RESET_CURRENT_VENDOR,
    REQUEST_CREATING_VENDOR,
    CREATE_VENDOR_SUCCESS,
    CREATE_VENDOR_FAILURE,
    REQUEST_EDITING_VENDOR,
    EDIT_VENDOR_SUCCESS,
    EDIT_VENDOR_FAILURE,
    REQUEST_VENDOR_DETAIL,
    FETCH_VENDOR_DETAIL_SUCCESS,
    FETCH_VENDOR_DETAIL_FAILURE,
    REQUEST_VENDOR_INVENTORY_DETAIL,
    FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS,
    FETCH_VENDOR_INVENTORY_DETAIL_FAILURE,
    REQUEST_VENDOR_RECORDS,
    FETCH_VENDOR_RECORDS_SUCCESS,
    FETCH_VENDOR_RECORDS_FAILURE,
    FETCH_VENDOR_BATCHES,
    FETCH_VENDOR_BATCHES_SUCCESS,
    FETCH_VENDOR_BATCHES_FAILURE,
    ATTACH_DOCUMENT,
    ATTACH_DOCUMENT_SUCCESS,
    ATTACH_DOCUMENT_FAILURE,
    FETCH_VENDOR_PRICE_TABLE,
    FETCH_VENDOR_PRICE_TABLE_FAILURE,
    FETCH_VENDOR_PRICE_TABLE_SUCCESS,
    FETCH_VENDOR_PRODUCTS,
    FETCH_VENDOR_PRODUCTS_FAILURE,
    FETCH_VENDOR_PRODUCTS_SUCCESS,
    CREATE_VENDOR_PRICE_ITEM,
    UPDATE_VENDOR_PRICE_ITEM,
    DELETE_VENDOR_PRICE_ITEM,
    FETCH_VENDOR_PRICE_TABLE_DETAIL,
    FETCH_VENDOR_PRICE_TABLE_DETAIL_FAILURE,
    FETCH_VENDOR_PRICE_TABLE_DETAIL_SUCCESS,
    UPDATE_VENDOR_PRICE_TABLE, UPDATE_VENDOR_PRICE_TABLE_FAILURE, UPDATE_VENDOR_PRICE_TABLE_SUCCESS,
} from '../actions/type';
import moment from 'moment'

const INITIAL_STATE = {
    all: [],
    currentVendor: null,
    currentVendorDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    currentVendorInventoryDetail: null,
    vendorInventoryDetailError: null,
    vendorInventoryDetailIsLoading: false,
    vendorRecords: [],
    vendorRecordsIsLoading: null,
    vendorRecordsError: null,
    vendorBatchesIsLoading: false,
    vendorBatchesError: null,
    vendorBatches: null,
    isAttachingDocument: false,
    priceTable: {
        all: [],
        isLoading: false,
        currentProduct: {},
        currentVendorPrice: {
            Quote_date: moment(),
            Quote_Validity: moment(),
            priceList: [],
        },
    },
    vendorProducts: [],
    isLoadingVendorProducts: false,
    isLoadingVendorPriceTableDetail: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_VENDORS:
            return { ...state, error: null, isLoading: true };
        case FETCH_VENDORS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_VENDORS_FAILURE:
            const error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_VENDOR:
            return { ...state, currentVendor: action.payload };
        case RESET_CURRENT_VENDOR:
            return { ...state, currentVendor: null, currentVendorDetail: null, editError: null, createError: null };
        case REQUEST_CREATING_VENDOR:
            return { ...state, isCreating: true, createError: null, created: false };
        case CREATE_VENDOR_SUCCESS:
            return { ...state, isCreating: false, createError: null, created: true };
        case CREATE_VENDOR_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            alert(JSON.stringify(createError));
            return { ...state, isCreating: false, createError: createError, created: false };
        case REQUEST_EDITING_VENDOR:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_VENDOR_SUCCESS:
            return { ...state, isEditing: false, editError: null, edited: true };
        case EDIT_VENDOR_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            alert(JSON.stringify(editError));
            return { ...state, isEditing: false, editError: editError, edited: false };
        case REQUEST_VENDOR_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_VENDOR_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentVendorDetail: action.payload.data, detailError: null, detailIsLoading: false };
        case FETCH_VENDOR_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_VENDOR_INVENTORY_DETAIL:
            return { ...state, currentVendorInventoryDetail: null, vendorInventoryDetailError: null, vendorInventoryDetailIsLoading: true };
        case FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentVendorInventoryDetail: action.payload.data, vendorInventoryDetailError: null, vendorInventoryDetailIsLoading: false };
        case FETCH_VENDOR_INVENTORY_DETAIL_FAILURE:// return error and make loading = false
            const vendorInventoryDetailError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, vendorInventoryDetailError: vendorInventoryDetailError, vendorInventoryDetailIsLoading: false };
        case REQUEST_VENDOR_RECORDS:
            return { ...state, vendorRecordsIsLoading: true, vendorRecordsError: null, vendorRecords: [] };
        case FETCH_VENDOR_RECORDS_SUCCESS:
            return { ...state, vendorRecordsIsLoading: false, vendorRecords: action.payload.data };
        case FETCH_VENDOR_RECORDS_FAILURE:
            const vendorRecordsError = action.payload || { message: action.payload.message };
            return { ...state, vendorRecordsIsLoading: false, vendorRecordsError: vendorRecordsError };
        case FETCH_VENDOR_BATCHES:
            return { ...state, vendorBatchesIsLoading: true, vendorBatchesError: null, vendorBatches: [] };
        case FETCH_VENDOR_BATCHES_SUCCESS:
            return { ...state, vendorBatchesIsLoading: false, vendorBatches: action.payload.data };
        case FETCH_VENDOR_BATCHES_FAILURE:
            const vendorBatchesError = action.payload || { message: action.payload.message };
            return { ...state, vendorBatchesIsLoading: false, vendorBatchesError: vendorBatchesError };
        case ATTACH_DOCUMENT:
            return { ...state, isAttachingDocument: true, attachDocumentError: null, attachDocumentSuccess: false };
        case ATTACH_DOCUMENT_SUCCESS:
            return { ...state, isAttachingDocument: false, attachDocumentError: null, attachDocumentSuccess: true };
        case ATTACH_DOCUMENT_FAILURE:
            const attachDocumentError = action.payload.data || { message: action.payload.message };
            // alert(JSON.stringify(attachDocumentError));
            return { ...state, isAttachingDocument: false, attachDocumentError, attachDocumentSuccess: false };
        case FETCH_VENDOR_PRICE_TABLE:
        case FETCH_VENDOR_PRICE_TABLE_FAILURE:
            return { ...state, priceTable: {...state.priceTable, isLoading: action.type === FETCH_VENDOR_PRICE_TABLE, all: []}};
        case FETCH_VENDOR_PRICE_TABLE_SUCCESS:
            return { ...state, priceTable: {...state.priceTable, isLoading: false, all: action.data}};
        case FETCH_VENDOR_PRODUCTS:
        case FETCH_VENDOR_PRODUCTS_FAILURE:
            return { ...state, isLoadingVendorProducts: action.type === FETCH_VENDOR_PRICE_TABLE, vendorProducts: []};
        case FETCH_VENDOR_PRODUCTS_SUCCESS:
            return { ...state, isLoadingVendorProducts: false, vendorProducts: action.data};
        case CREATE_VENDOR_PRICE_ITEM:
        case UPDATE_VENDOR_PRICE_ITEM:
        case DELETE_VENDOR_PRICE_ITEM:
            if (action.type === CREATE_VENDOR_PRICE_ITEM) {
                state.priceTable.currentVendorPrice.priceList.push(action.item);
            }
            if (action.type === UPDATE_VENDOR_PRICE_ITEM) {
                state.priceTable.currentVendorPrice.priceList[action.index] = action.item;
            }
            if (action.type === DELETE_VENDOR_PRICE_ITEM) {
                state.priceTable.currentVendorPrice.priceList.splice(action.index, 1);
            }
            return {
                ...state,
                priceTable: {
                    ...state.priceTable,
                    currentVendorPrice: {
                        ...state.priceTable.currentVendorPrice,
                        priceList: [
                            ...state.priceTable.currentVendorPrice.priceList
                        ]
                    }
                }
            }
        case FETCH_VENDOR_PRICE_TABLE_DETAIL:
        case FETCH_VENDOR_PRICE_TABLE_DETAIL_FAILURE:
            return {
                ...state,
                isLoadingVendorPriceTableDetail: action.type === FETCH_VENDOR_PRICE_TABLE_DETAIL,
                priceTable: {
                    ...state.priceTable,
                    currentVendorPrice: {
                        ...INITIAL_STATE.priceTable.currentVendorPrice
                    }
                }
            }
        case FETCH_VENDOR_PRICE_TABLE_DETAIL_SUCCESS:
            return {
                ...state,
                isLoadingVendorPriceTableDetail: false,
                priceTable: {
                    ...state.priceTable,
                    currentVendorPrice: action.data,
                }
            }
        case UPDATE_VENDOR_PRICE_TABLE:
        case UPDATE_VENDOR_PRICE_TABLE_FAILURE:
            return {
                ...state,
                isLoadingVendorPriceTableDetail: action.type === UPDATE_VENDOR_PRICE_TABLE,
            }
        case UPDATE_VENDOR_PRICE_TABLE_SUCCESS:
            return {
                ...state,
                isLoadingVendorPriceTableDetail: false,
                priceTable: {
                    ...state.priceTable,
                    currentVendorPrice: {
                        ...INITIAL_STATE.priceTable.currentVendorPrice
                    },
                }
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/vendors_reducer.js